import { Component } from '@angular/core';
import { AlertService, Alert } from '../alert.service';

@Component({
	selector: 'tacho-alert',
	templateUrl: './alert.component.html',
	styleUrls: ['./alert.component.scss']
})
export class AlertComponent {
	public timeout = 6000;

	public messages: Alert[] = [];

	constructor(public alertService: AlertService) {
		this.alertService.getMessages().subscribe(msg => {
			this.messages.push(msg);
		});

		this.alertService.clearAll$.subscribe(() => {
			this.messages = [];
		});
	}

	close(alert: Alert): void {
		this.messages.splice(this.messages.indexOf(alert), 1);
	}
}
